import { useState } from 'react';

interface FAQ {
  question: string;
  answer: string;
}

const faqs: FAQ[] = [
  {
    question: '艳姆1—6系列讲的是什么故事？',
    answer: '艳姆1—6是一部以情感叙事为核心的动画系列作品，讲述了主角团在命运推动下经历的一系列冒险与成长故事。系列通过精致的画面语言、深刻的人物塑造和巧妙的剧情设计，呈现了一个关于选择、牺牲与成长的动人故事。全系列共6集，每集都有独立的主题侧重，同时又相互关联，共同构建了一个完整而富有深度的叙事体系。',
  },
  {
    question: '艳姆1—6应该按照什么顺序观看？',
    answer: '强烈建议按照1—6集的自然顺序观看。该系列采用了严格的线性递进叙事结构，每一集的内容都建立在之前剧情的基础之上。跳过任何一集都可能导致对后续剧情理解的不完整。对于希望深入研究作品的观众，可以尝试"三遍观看法"：第一遍关注主线剧情，第二遍留意细节伏笔，第三遍聚焦视听语言。',
  },
  {
    question: '艳姆1—6系列有哪些突出的亮点？',
    answer: '艳姆1—6系列的亮点体现在多个维度：在视觉层面，独特的艺术风格和精湛的光影运用令人印象深刻；在叙事层面，精密的伏笔设计和层层递进的情感推进展现了高超的编剧功力；在角色层面，立体丰满的人物塑造让每个角色都具有独特的魅力；在配乐层面，高品质的原声带和精准的音效设计极大地增强了观看的沉浸感。',
  },
  {
    question: '艳姆1—6第6集结局是怎样的？',
    answer: '第6集为整个系列画上了一个令人满意的句号。在解决了所有主要剧情冲突的同时，结局设计巧妙地保留了适度的开放式解读空间。通过主角的独白和精心设计的蒙太奇画面，系列的核心主题——关于选择、牺牲与成长——得到了最终的升华。结局在满足观众期待的同时，也为系列留下了持续讨论和解读的余地。',
  },
  {
    question: '艳姆1—6系列适合什么年龄段的观众？',
    answer: '艳姆1—6系列以其深刻的主题表达和细腻的情感描绘而著称，作品中包含了较为成熟的叙事内容和情感探讨，建议青少年及以上年龄段的观众观看。不同年龄段的观众可能从作品中获得不同层次的理解和感悟，这也是该系列的一大魅力所在。',
  },
  {
    question: '如何获取艳姆1—6系列的观看资源？',
    answer: '艳姆1—6系列可在各大主流视频平台观看。建议选择画质较高的播放源以获得最佳观看体验，同时推荐使用优质耳机或音响设备观看，以充分体验该系列精致的声音设计。具体平台信息和资源更新，请关注本站"观看指引"分类下的最新文章。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-foreground-600 mt-2 text-sm">
            关于艳姆1—6系列的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left transition-colors hover:bg-background-100/50"
              >
                <span className="text-sm font-medium text-foreground-900 font-heading pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}